// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-n_fN","advertDetailHeaderLocation__value":"c-n_fO"};